module.exports = __webpack_public_path__ + "static/img/123.5f5d8dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/123.png
// module id = VjIu
// module chunks = 1